import api from './api';

const budgetMarginRulesService = {
  getAll: async (params = {}) => {
    const response = await api.get('/budget-margin-rules', { params });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/budget-margin-rules', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/budget-margin-rules/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/budget-margin-rules/${id}`);
    return response.data;
  }
};

export default budgetMarginRulesService;
